import { useQuery } from 'convex/react'
import { api } from '../../convex/_generated/api'
import './About.css'

const defaultTeam = [
  {
    name: 'Ashok',
    role: 'Founder & Lead Accountant',
    bio: 'With over 15 years of experience in accounting and tax services, Ashok leads our team with expertise and dedication.'
  }
]

function About() {
  const dbTeam = useQuery(api.teamMembers.listActive)
  const team = dbTeam && dbTeam.length > 0 ? dbTeam : defaultTeam

  return (
    <div className="about">
      <div className="container">
        {/* About Section */}
        <section className="about-intro">
          <h1>About Omni Accounting & Tax</h1>
          <p className="lead">
            We are a trusted provider of professional tax and accounting services dedicated to helping individuals and businesses navigate their financial obligations with ease.
          </p>
        </section>

        {/* Mission & Vision */}
        <section className="mission-vision">
          <div className="card">
            <h2>Our Mission</h2>
            <p>
              To provide comprehensive, personalized accounting and tax services that help our clients achieve financial success and peace of mind.
            </p>
          </div>
          <div className="card">
            <h2>Our Values</h2>
            <p>
              Integrity, professionalism, and client-focused service excellence define everything we do.
            </p>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="why-us">
          <h2>Why Choose Us?</h2>
          <div className="features-grid">
            <div className="feature">
              <h3>Expert Knowledge</h3>
              <p>Our team stays current with the latest tax laws and accounting standards.</p>
            </div>
            <div className="feature">
              <h3>Personalized Service</h3>
              <p>We tailor our services to meet your unique financial needs and goals.</p>
            </div>
            <div className="feature">
              <h3>Proactive Planning</h3>
              <p>We work with you to develop strategies that minimize tax liability.</p>
            </div>
            <div className="feature">
              <h3>Transparent Pricing</h3>
              <p>No hidden fees. Clear, straightforward pricing from the start.</p>
            </div>
            <div className="feature">
              <h3>Responsive Support</h3>
              <p>We're here when you need us with prompt, helpful guidance.</p>
            </div>
            <div className="feature">
              <h3>Business Focused</h3>
              <p>We understand the unique challenges of running a business.</p>
            </div>
          </div>
        </section>

        {/* Team */}
        <section className="team">
          <h2>Our Team</h2>
          <div className="team-grid">
            {team.map((member, index) => (
              <div key={member._id ?? index} className="team-card">
                <h3>{member.name}</h3>
                <p className="role">{member.role}</p>
                <p>{member.bio}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  )
}

export default About
